'use strict';

var fragmentMasking = require('./types/fragment-masking.js');

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const withFragment = (fragment, callback)=>(props)=>{
        const { data: maybeFragmentData } = props, rest = _object_without_properties_loose(props, [
            "data"
        ]);
        var _getFragmentData;
        const data = (_getFragmentData = fragmentMasking.getFragmentData(fragment, maybeFragmentData)) != null ? _getFragmentData : null;
        return callback(data, rest);
    };

module.exports = withFragment;
